var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.061,19.439,54.5,10.879V7.5A3.5,3.5,0,0,0,51,4H13A3.5,3.5,0,0,0,9.5,7.5v3.379L.939,19.439A1.688,1.688,0,0,0,.5,20.5v36A3.5,3.5,0,0,0,4,60H60a3.5,3.5,0,0,0,3.5-3.5v-36A1.69,1.69,0,0,0,63.061,19.439Zm-3.307.936-5.254,4.2V15.121ZM12.5,7.5A.5.5,0,0,1,13,7H51a.5.5,0,0,1,.5.5V26.979L32,42.579l-19.5-15.6Zm-3,17.079-5.254-4.2L9.5,15.121ZM60.5,56.5a.5.5,0,0,1-.5.5H4a.5.5,0,0,1-.5-.5V23.621l27.562,22.05a1.5,1.5,0,0,0,1.875,0L60.5,23.621Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.515,51H8a1.5,1.5,0,0,0,0,3H25.515a1.5,1.5,0,0,0,0-3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47,10H17a1.5,1.5,0,0,0-1.5,1.5V24.816a1.5,1.5,0,0,0,.562,1.172l15,12a1.5,1.5,0,0,0,1.875,0l15-12a1.5,1.5,0,0,0,.563-1.172V11.5A1.5,1.5,0,0,0,47,10ZM37.374,26.333H26.626a1.5,1.5,0,0,1,0-3H37.374a1.5,1.5,0,0,1,0,3ZM41,19.667H23a1.5,1.5,0,0,1,0-3H41a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#26A7DE"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.653c0356c751958952d8468aaa1c4e31.svg";
export { ForwardRef as ReactComponent };